// extracted by css-extract-rspack-plugin
export default {"jobsViewerHeader":"jobsViewerHeader-Xmg5R0"};